import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import { Root, Viewbox, TopStroke, RightStroke, BottomStroke, LeftStroke } from './styles/box-control-icon-styles';
var BASE_ICON_SIZE = 24;
export default function BoxControlIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$side = _ref.side,
      side = _ref$side === void 0 ? 'all' : _ref$side,
      props = _objectWithoutProperties(_ref, ["size", "side"]);

  var top = getSide(side, 'top');
  var right = getSide(side, 'right');
  var bottom = getSide(side, 'bottom');
  var left = getSide(side, 'left'); // Simulates SVG Icon scaling

  var scale = size / BASE_ICON_SIZE;
  return createElement(Root, _extends({
    style: {
      transform: "scale(".concat(scale, ")")
    }
  }, props), createElement(Viewbox, null, createElement(TopStroke, {
    isFocused: top
  }), createElement(RightStroke, {
    isFocused: right
  }), createElement(BottomStroke, {
    isFocused: bottom
  }), createElement(LeftStroke, {
    isFocused: left
  })));
}

function getSide(side, value) {
  return side === 'all' || side === value;
}
//# sourceMappingURL=icon.js.map